import { combineReducers } from 'redux';
import { rightSider } from 'components/page/RightSider/flow/reducer';
import { pageLoading } from 'components/page/PageLoading/flow/reducer';
import siders from 'components/page/EnhancedSider/flow/reducer';

export default combineReducers({
  rightSider,
  pageLoading,
  siders,
});



// WEBPACK FOOTER //
// ./src/store/uiReducer.js